import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

import DependingObjects from '../../components/psc/lib/DependingObjects'
import CancelButton from '../../components/psc/lib/CancelButton'
import SaveButton from '../../components/psc/lib/SaveButton'
import DeleteButton from '../../components/psc/lib/DeleteButton'
import ErrorMessage from '../../components/psc/lib/ErrorMessage'

const Model = () => {
    let { objID } = useParams()
    const isNew = objID === "new" ? true : false
    objID = parseInt(objID,10)
    const objectUrl = '/v0/models' + (isNew ? '' : '/' + objID)

    // Fields
    const [name, setName] = useState('')
    const [code, setCode] = useState('')

    // Read-only
    const [isUsed, setIsUsed] = useState(false)
    const [dependingObjects, setDependingObjects] = useState([])

    // Submit
    const [submitActive, setSubmitActive] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        if ( ! isNew) {
            fetchObject()
        }
    }, [isNew])

    const fetchObject = () => {
        fetch(objectUrl, { credentials: 'same-origin' })
            .then(function(response) {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error(response.statusText)
                }
            })
            .then(function(json) {
                if(json.error) {
                    throw new Error(json.error)
                }

                fromBackend(json.result)
            })
            .catch(function(error) {
                console.log(error)
            })
    }

    const fromBackend = (obj) => {
        setName(obj.name)
        setCode(obj.code)
        setIsUsed(obj.is_used)
        setDependingObjects(obj.depending_objects)
    }

    const toBackend = () => {
        return {
            code: code.trim(),
            name: name.trim(),
        }
    }

    const validateBeforeSubmit = () => {
        let errors = []

        if ( ! code ) {
            errors.push('Code is required')
        }

        if ( ! name ) {
            errors.push('Name is required')
        }

        if ( errors.length > 0 ) {
            setError(errors)
            return false
        }

        return true
    }

    const handleSubmitError = (props) => {
        setSubmitActive(false)
        setError([ props.message ])
    }
    
    const handleSubmit = (event) => {
        if( event ) {
            event.preventDefault()
        }
        if( submitActive || !validateBeforeSubmit() ) {
            return null
        }

        setSubmitActive(true)

        return {
            objType: 'models',
            objID: objID,
            data: toBackend(),
        }
    }

    let requiredIndicator = (<label className="form-required-star">&nbsp;*</label>);

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Model: {name || '<New Model>'}</h2>
                        </div>
                        <div className="ibox-content">
                            <form className="form-horizontal" onSubmit={(e) => handleSubmit(e)}>
                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Code
                                        {isNew && requiredIndicator}
                                    </label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="text"
                                            value={code}
                                            onChange={(e) => setCode(e.target.value.toUpperCase())}
                                            disabled={!isNew}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Name
                                        {requiredIndicator}
                                    </label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="text"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required 
                                        />
                                    </div>
                                </div>

                                <div className="hr-line-dashed"></div>

                                <div className="form-group">
                                    <ErrorMessage
                                        error={error}
                                    />

                                    <div className="col-sm-10 col-sm-offset-2">
                                        <CancelButton />
                                        
                                        <SaveButton
                                            buttonVariant='primary'
                                            visible={true}
                                            spinnerActive={submitActive}
                                            label='Save Changes'
                                            onClick={handleSubmit}
                                            onError={handleSubmitError}
                                        />

                                        <DependingObjects list={dependingObjects} />

                                        <DeleteButton
                                           isHidden={isNew || isUsed}
                                           url={objectUrl}
                                           onError={handleSubmitError}
                                        />

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Model
